import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAdminAuthed, signInWithApi } from '../../data/adminAuth';
import { pic } from '../../data/site';
import logo from '../../assets/images/hola-caribe-logo.svg';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [mode, setMode] = useState('login'); // 'login' | 'forgot'
  const [email, setEmail] = useState('admin@holacaribe.travel');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(true);
  const [error, setError] = useState(null); // null | message
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    if (isAdminAuthed()) navigate('/admin', { replace: true });
  }, [navigate]);

  const signIn = async () => {
    if (loading) return;
    if (!email.trim() || !password.trim()) { setError('Enter your email and password to continue.'); return; }
    setError(null);
    setLoading(true);
    try {
      await signInWithApi(email.trim(), password);
      navigate('/admin', { replace: true });
    } catch (e) {
      setError(e.message || 'Sign-in failed, please try again.');
    } finally {
      setLoading(false);
    }
  };

  const onKey = (e) => { if (e.key === 'Enter') signIn(); };

  return (
    <div className="admin-bg" style={{ minHeight:'100vh', display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(320px,1fr))' }}>
      {/* Brand panel */}
      <div style={{ position:'relative', minHeight:340, overflow:'hidden' }}>
        <div className="cover bgimg" style={{ backgroundImage:`url(${pic('caribbean,beach,turquoise,palm', 1, 1200, 1400)})` }}></div>
        <div className="cover" style={{ background:'linear-gradient(160deg,rgba(12,43,47,0.55),rgba(4,34,42,0.9))' }}></div>
        <div style={{ position:'relative', height:'100%', display:'flex', flexDirection:'column', justifyContent:'space-between', padding:44, color:'#fff' }}>
          <div>
            <img src={logo} alt="HolaCaribe" style={{ height:76, display:'block' }} />
          </div>
          <div>
            <div className="serif" style={{ fontSize:'clamp(30px,3.6vw,46px)', lineHeight:1.08, maxWidth:'14ch' }}>Happiness without borders.</div>
            <div style={{ fontSize:15, opacity:.75, marginTop:14 }}>Internal back-office · v2.4</div>
          </div>
        </div>
      </div>

      {/* Form panel */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:'44px 28px' }}>
        <div style={{ width:'100%', maxWidth:420, padding:38, borderRadius:26, background:'rgba(255,255,255,0.62)', backdropFilter:'blur(26px) saturate(170%)', WebkitBackdropFilter:'blur(26px) saturate(170%)', border:'1px solid rgba(255,255,255,0.8)', boxShadow:'0 24px 60px rgba(16,90,90,0.22)', animation:'floatUp .5s ease both' }}>
          {/* Light glass panel — the white-text logo needs the brand-gradient tile behind it. */}
          <div style={{ width:64, height:60, borderRadius:16, background:'linear-gradient(140deg,#26c6a3,#0e8a9c)', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 10px 22px rgba(14,138,156,0.35)', marginBottom:20 }}>
            <img src={logo} alt="HolaCaribe" style={{ height:44, display:'block' }} />
          </div>

          {mode === 'login' && (
            <div>
              <h1 className="serif" style={{ fontSize:32, margin:'0 0 6px', letterSpacing:'-0.3px' }}>Sign in to Admin</h1>
              <p style={{ fontSize:14.5, color:'#5a726f', margin:'0 0 22px' }}>Manage destinations, bookings and everything the public site shows.</p>
              {error && (
                <div style={{ display:'flex', gap:10, alignItems:'flex-start', padding:'14px 16px', borderRadius:14, background:'rgba(192,73,47,0.1)', border:'1px solid rgba(192,73,47,0.3)', marginBottom:16 }}>
                  <span style={{ flexShrink:0, width:20, height:20, borderRadius:'50%', background:'#c0492f', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:800 }}>!</span>
                  <div style={{ fontSize:13.5, lineHeight:1.5, color:'#93341f', fontWeight:600 }}>{error}</div>
                </div>
              )}
              <div style={{ display:'grid', gap:14 }}>
                <label style={{ display:'block' }}>
                  <span className="a-label">Email</span>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={onKey} className="a-input" />
                </label>
                <label style={{ display:'block' }}>
                  <span className="a-label">Password</span>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={onKey} className="a-input" />
                </label>
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:12 }}>
                  <label style={{ display:'flex', alignItems:'center', gap:9, fontSize:14, fontWeight:600, color:'#0c2b2f', cursor:'pointer' }}>
                    <span onClick={() => setRemember(r => !r)} style={{ width:20, height:20, borderRadius:6, background: remember ? 'linear-gradient(135deg,#26c6a3,#0e8a9c)' : 'rgba(255,255,255,0.85)', border: remember ? 'none' : '1px solid #f2e2d2', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:800 }}>{remember ? '✓' : ''}</span>
                    Remember me
                  </label>
                  <span onClick={() => { setMode('forgot'); setSent(false); }} style={{ cursor:'pointer', fontSize:13.5, fontWeight:700, color:'#5a726f' }}>Forgot password?</span>
                </div>
                <button onClick={signIn} className="a-primary" style={{ padding:15, borderRadius:14, fontSize:15, boxShadow:'0 12px 26px rgba(14,138,156,0.35)', opacity: loading ? 0.72 : 1 }}>
                  {loading ? 'Signing in…' : 'Sign in'}
                </button>
              </div>
            </div>
          )}

          {mode === 'forgot' && (
            <div>
              <h1 className="serif" style={{ fontSize:32, margin:'0 0 6px', letterSpacing:'-0.3px' }}>Forgot password</h1>
              <p style={{ fontSize:14.5, color:'#5a726f', margin:'0 0 22px' }}>Enter your work email and we'll send a reset link. It expires in 30 minutes.</p>
              {sent && (
                <div style={{ display:'flex', gap:10, alignItems:'flex-start', padding:'14px 16px', borderRadius:14, background:'rgba(26,122,72,0.1)', border:'1px solid rgba(26,122,72,0.3)', marginBottom:16 }}>
                  <span style={{ flexShrink:0, width:20, height:20, borderRadius:'50%', background:'#1a7a48', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:800 }}>✓</span>
                  <div style={{ fontSize:13.5, lineHeight:1.5, color:'#1a5c38', fontWeight:600 }}>If that email exists, a reset link is on its way.</div>
                </div>
              )}
              <div style={{ display:'grid', gap:14 }}>
                <label style={{ display:'block' }}>
                  <span className="a-label">Email</span>
                  <input type="email" placeholder="you@holacaribe.travel" className="a-input" />
                </label>
                <button onClick={() => setSent(true)} className="a-primary" style={{ padding:15, borderRadius:14, fontSize:15, boxShadow:'0 12px 26px rgba(14,138,156,0.35)' }}>Send reset link</button>
                <span onClick={() => setMode('login')} style={{ cursor:'pointer', textAlign:'center', fontSize:14, fontWeight:700, color:'#5a726f' }}>← Back to sign in</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
